
@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in-fast">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-lg p-6 text-slate-800 m-4">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-gray-800">เชิญพนักงานใหม่ (Invite Staff)</h2>
        <button (click)="onClose()" class="text-gray-400 hover:text-gray-600 transition-colors" title="ปิดหน้าต่าง">
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>
      
      @if (inviteLink()) {
        <div class="text-center space-y-4">
            <div class="p-4 bg-green-50 border-l-4 border-green-500 rounded-r-lg text-left animate-fade-in">
                <p class="font-bold text-green-800 flex items-center gap-2">
                    <i class="fa-solid fa-circle-check"></i> สร้างลิงก์สำเร็จ!
                </p>
                <p class="text-sm text-green-700 mt-1">
                    ระบบไม่ได้ส่งอีเมลอัตโนมัติ <strong>กรุณาคัดลอกลิงก์ด้านล่าง</strong> และส่งให้พนักงานผ่านทาง Line หรือแชท
                </p>
            </div>
            
            <div class="relative group">
                <div class="bg-slate-100 p-3 rounded-lg border border-slate-300 flex items-center gap-2">
                    <i class="fa-solid fa-link text-slate-400"></i>
                    <input type="text" [value]="inviteLink()" readonly class="bg-transparent text-sm text-slate-600 w-full outline-none font-mono" #linkInput>
                </div>
                <button (click)="copyToClipboard()" class="mt-3 w-full bg-emerald-600 text-white py-2.5 rounded-lg text-sm font-bold hover:bg-emerald-700 transition-all flex items-center justify-center gap-2 shadow-md hover:shadow-lg active:scale-95">
                    <i class="fa-regular fa-copy"></i> {{ copyButtonText() }}
                </button>
            </div>

            <div class="text-xs text-slate-400 pt-2">
                ลิงก์นี้จะหมดอายุภายใน 7 วัน
            </div>

            <button (click)="onClose()" class="text-slate-500 hover:text-slate-800 text-sm font-semibold underline">ปิดหน้าต่าง</button>
        </div>
      } @else {
        <form [formGroup]="inviteForm" (ngSubmit)="sendInvite()">
            <div class="space-y-5">
                <div>
                    <label for="email" class="block text-sm font-bold text-gray-700 mb-1">อีเมลพนักงาน (Email)</label>
                    <input id="email" type="email" formControlName="email" placeholder="employee@example.com" class="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm py-2.5 px-3 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm transition-all">
                    <p class="text-xs text-slate-500 mt-1">พนักงานจะใช้อีเมลนี้ในการล็อกอินเข้าระบบ</p>
                </div>
                <div>
                    <label for="role" class="block text-sm font-bold text-gray-700 mb-1">ตำแหน่ง (Role)</label>
                    <div class="relative">
                        <select id="role" formControlName="role" class="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm py-2.5 px-3 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm bg-white appearance-none cursor-pointer">
                            <option value="staff">พนักงานทั่วไป (Staff) - จัดการสต็อกได้</option>
                            <option value="cashier">แคชเชียร์ (Cashier) - ขายและรับเงิน</option>
                            <option value="doctor">แพทย์ (Doctor) - ตรวจรักษา/ออกใบรับรอง</option>
                            <option value="accountant">บัญชี (Accountant) - ดูรายงานได้</option>
                            <option value="admin">ผู้จัดการ (Admin) - แก้ไขได้ทุกอย่าง</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-700">
                            <i class="fa-solid fa-chevron-down text-xs"></i>
                        </div>
                    </div>
                </div>
                
                @if (errorMessage()) {
                    <div class="bg-red-50 border border-red-200 text-red-600 text-sm p-3 rounded-lg flex items-center gap-2">
                        <i class="fa-solid fa-circle-exclamation"></i> {{ errorMessage() }}
                    </div>
                }
            </div>

            <div class="mt-8 flex justify-end gap-3 border-t pt-4">
                <button type="button" (click)="onClose()" class="bg-white border border-gray-300 text-gray-700 px-4 py-2.5 rounded-lg hover:bg-gray-50 font-semibold transition-colors text-sm">ยกเลิก</button>
                <button type="submit" [disabled]="inviteForm.invalid || isSubmitting()" class="bg-emerald-600 text-white px-6 py-2.5 rounded-lg hover:bg-emerald-700 disabled:bg-slate-300 disabled:cursor-not-allowed font-bold transition-all shadow-sm flex items-center gap-2">
                @if (isSubmitting()) {
                    <i class="fa-solid fa-spinner animate-spin"></i> กำลังสร้าง...
                } @else {
                    <i class="fa-solid fa-link"></i> สร้างลิงก์คำเชิญ
                }
                </button>
            </div>
        </form>
      }
    </div>
  </div>
}
